module.exports = __webpack_public_path__ + "static/media/grabit.65a36446.jpg";